var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view live",attrs:{"data-name":"live"}},[_c('LiveContent'),_c('FakeImages',{attrs:{"imageOne":'/static/img/live_hero1.jpg',"imageTwo":'/static/img/live_hero2.jpg'}}),_c('PageHero',{attrs:{"title":'Live.',"text":''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }